var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerminal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.67208 16.0986C3.27833 16.0986 2.94313 15.9602 2.66646 15.6836C2.38993 15.407 2.25167 15.0718 2.25167 14.6779V5.32211C2.25167 4.92823 2.38993 4.59302 2.66646 4.31649C2.94313 4.03982 3.27833 3.90149 3.67208 3.90149H16.3279C16.7217 3.90149 17.0569 4.03982 17.3335 4.31649C17.6101 4.59302 17.7483 4.92823 17.7483 5.32211V14.6779C17.7483 15.0718 17.6101 15.407 17.3335 15.6836C17.0569 15.9602 16.7217 16.0986 16.3279 16.0986H3.67208ZM3.67396 14.9327H16.326C16.3902 14.9327 16.449 14.906 16.5025 14.8525C16.5558 14.7992 16.5825 14.7404 16.5825 14.6763V6.70045H3.4175V14.6763C3.4175 14.7404 3.44417 14.7992 3.4975 14.8525C3.55097 14.906 3.60979 14.9327 3.67396 14.9327ZM6.25 13.7925L5.44063 12.9832L7.58646 10.8165L5.41979 8.64982L6.25 7.83649L9.23 10.8165L6.25 13.7925ZM10.2525 13.8975V12.7317H14.7517V13.8975H10.2525Z",
    fill: "#90A4B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.ff4eae8a8584326cc41bef579a215225.svg";
export { ForwardRef as ReactComponent };